module.exports = __webpack_public_path__ + "ed8e9a466c693b31686f8020391993e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-ilernia.png
// module id = 105
// module chunks = 0